import dynaForms from '@elab/core/utils/dynaForms';

export const storeName = 'newsletter-subscription';

export default {
    ...dynaForms.getTypes(storeName),
    SET_NEWSLETTER_SUBSCRIPTION_INFO: `${storeName}.SET_NEWSLETTER_SUBSCRIPTION_INFO`,
};
